import { generatePath, useLocation, useParams } from 'react-router'
import type { PlatformName } from '@/analytics/types'
import { getActivePlatformName } from './routes.constants'

// Brand-scoped pages carry their identity in the path: /<platform>/:brandId/...; the platform is the
// first segment, so it is never repeated as a param.
export const useBrandRoute = () => {
  const { brandId, audienceId } = useParams<{ brandId: string; audienceId: string }>()
  const { pathname } = useLocation()
  const platform = (getActivePlatformName(pathname) ?? undefined) as PlatformName | undefined
  return { brandId, audienceId, platform }
}

export const isBrandId = (value: string | null | undefined): value is string =>
  !!value && /^\d+$/.test(value)

export const buildPlatformRoute = (
  route: string,
  params: { brandId: string | number; audienceId?: string | number }
) =>
  generatePath(route, {
    brandId: String(params.brandId),
    ...(params.audienceId !== undefined ? { audienceId: String(params.audienceId) } : {}),
  })
